import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "monthNavigator" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "center" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_chevronLeft = _resolveComponent("icon-chevronLeft")!
  const _component_icon_chevronRight = _resolveComponent("icon-chevronRight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
      }, [
        _createVNode(_component_icon_chevronLeft, { class: "text-green" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$filters.date(_ctx.localValue, 'MMMM YYYY')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
        disabled: !_ctx.canNext
      }, [
        _createVNode(_component_icon_chevronRight, { class: "text-green" })
      ], 8, _hoisted_5)
    ])
  ]))
}